import { render, staticRenderFns } from "./ProjectPhasesTable.vue?vue&type=template&id=3a03e554&scoped=true&"
import script from "./ProjectPhasesTable.vue?vue&type=script&lang=js&"
export * from "./ProjectPhasesTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPhasesTable.vue?vue&type=style&index=0&id=3a03e554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a03e554",
  null
  
)

export default component.exports